<div class="d-flex justify-content-between align-items-center w-100 mt-1 mb-2">
	<p class="mt-3 mb-0 text-muted fw-700"></p>
	<button class="btn btn-sm btn-light rounded-2" (click)="fetchSessionEvents()" [disabled]="eventsLoading">
		<fa-icon icon="refresh"></fa-icon>
	</button>
</div>
<hr class="mt-0" />

@if (eventsLoading) {
	<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh">
		<app-pre-loading msg="Buscando eventos, aguarde"></app-pre-loading>
	</div>
} @else {
	@if (participants.length === 0) {
		<div class="d-flex align-items-center justify-content-center w-100" style="height: 50vh">
			<app-empty-data message="Nenhum participante no momento..."></app-empty-data>
		</div>
	} @else {
		<div class="p-3 pb-2 border-bottom bg-gray-100">
			<div class="d-flex justify-content-between align-items-center mb-2">
				<small class="text-muted d-block">Participantes ({{ participants.length }})</small>
				@if (selectedParticipantId) {
					<button class="btn btn-sm btn-link p-0" (click)="toggleParticipantFilter(selectedParticipantId)">Limpar filtro</button>
				}
			</div>
			<div class="d-flex flex-wrap gap-2">
				@for (participant of participants; track participant.id) {
					<small
						class="badge badge-sm rounded-2 fw-600 cursor-pointer"
						(click)="toggleParticipantFilter(participant.id)"
						[ngbTooltip]="participant.document | mask: 'CPF_CNPJ'"
						[class.text-bg-primary]="selectedParticipantId === participant.id"
						[class.text-bg-light]="selectedParticipantId !== participant.id"
						[class.border]="selectedParticipantId !== participant.id">
						<fa-icon icon="circle" class="me-1" [class.text-success]="participant.approved" [class.text-danger]="participant.rejected"></fa-icon>
						{{ participant.name }}
						<span class="ms-1 fw-300">({{ participant.statusLabel }})</span>
					</small>
				}
			</div>
		</div>

		<div class="p-3">
			@if (filteredEventGroups.length === 0) {
				<div class="p-5">
					<app-empty-data message="Nenhum evento encontrado..."></app-empty-data>
				</div>
			} @else {
				@for (group of filteredEventGroups; track group.dateLabel) {
					<div class="d-flex align-items-center mb-3">
						<small class="badge badge-sm text-bg-light border fw-600 text-uppercase">{{ group.dateLabel }}</small>
						<hr class="flex-grow-1 ms-2 my-0" />
					</div>

					<ul class="timeline-events list-unstyled ps-2 mb-4">
						@for (event of group.items; track event.id) {
							<li
								class="timeline-events-item ps-4 pb-4 position-relative border-start"
								[class.border-success]="event.approved"
								[class.border-danger]="event.rejected"
								[class.border-secondary]="!event.approved && !event.rejected">
								<span
									class="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white"
									style="width: 22px; height: 22px; left: -12px; top: 0"
									[class.bg-success]="event.approved"
									[class.bg-danger]="event.rejected"
									[class.bg-secondary]="!event.approved && !event.rejected">
									<fa-icon [icon]="eventSourceIcon(event.sourceTag)" style="font-size: 10px"></fa-icon>
								</span>

								<div class="d-flex justify-content-between align-items-center mb-1">
									<small class="text-muted">
										{{ event.supplierDocument | mask: 'CPF_CNPJ' }} —
										<b class="text-uppercase">{{ event.supplierName }}</b>
									</small>
									<small class="text-muted">{{ event.created | date: 'HH:mm' }}</small>
								</div>

								@if (event.submitted) {
									<app-pre-loading [inline]="true" [large]="false" msg="Baixando anexo, aguarde"></app-pre-loading>
								} @else {
									<div
										class="message-bubble system align-self-start"
										style="max-width: 100%"
										[class.cursor-pointer]="event.hasAttachment"
										(click)="eventAttachmentDownload(event, event.resourceId ?? event.id)"
										[innerHTML]="event.customMessage"></div>
								}
							</li>
						}
					</ul>
				}
			}
		</div>

		<hr />

		<div class="row p-3">
			<div class="col-md-6">
				<h6 class="fw-700 mb-2">Participantes Qualificados ({{ qualifiedParticipants.length }})</h6>
				<ul class="list-group list-group-flush">
					@for (participant of qualifiedParticipants; track participant.id) {
						<li
							class="list-group-item cursor-pointer d-flex justify-content-between align-items-center"
							[class.bg-gray-200]="selectedParticipantId === participant.id"
							(click)="toggleParticipantFilter(participant.id)">
							<div>
								<small class="text-muted d-block">{{ participant.document | mask: 'CPF_CNPJ' }}</small>
								<span class="fw-600 text-uppercase">{{ participant.name }}</span>
							</div>
							<fa-icon icon="circle-check" class="text-success"></fa-icon>
						</li>
					} @empty {
						<li class="list-group-item text-muted">Nenhum participante qualificado</li>
					}
				</ul>
			</div>
			<div class="col-md-6">
				<h6 class="fw-700 mb-2">Participantes Desclassificados ({{ rejectedParticipants.length }})</h6>
				<ul class="list-group list-group-flush">
					@for (participant of rejectedParticipants; track participant.id) {
						<li
							class="list-group-item cursor-pointer d-flex justify-content-between align-items-center"
							[class.bg-gray-200]="selectedParticipantId === participant.id"
							(click)="toggleParticipantFilter(participant.id)">
							<div>
								<small class="text-muted d-block">{{ participant.document | mask: 'CPF_CNPJ' }}</small>
								<span class="fw-600 text-uppercase">{{ participant.name }}</span>
							</div>
							<fa-icon icon="circle-xmark" class="text-danger"></fa-icon>
						</li>
					} @empty {
						<li class="list-group-item text-muted">Nenhum participante desclassificado</li>
					}
				</ul>
			</div>
		</div>
	}
}

<!--Modal view attachment-->
<ng-template #modalAttachment let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Anexo</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body m-0 p-0 overflow-y-hidden" style="height: 85vh">
		@if (attachmentLoading) {
			<div class="d-flex h-100 align-items-center justify-content-center">
				<app-pre-loading></app-pre-loading>
			</div>
		} @else {
			@if (attachmentUrl) {
				@if (attachmentUrl === 'error') {
					<div class="d-flex h-100 align-items-center justify-content-center">
						<app-empty-data message="Não foi possível baixar o documento..."></app-empty-data>
					</div>
				} @else {
					<iframe [src]="attachmentUrl" width="100%" height="100%" [frameBorder]="0"></iframe>
				}
			}
		}
	</div>
</ng-template>
